import {
    Question,
    QuestionLogicOperator,
    QuestionLogicAction,
    FormDetail,
    AnswerItem,
    QuestionLogic,
    QuestionTypes,
    AnswererInfo,
    PrevFormDetail,
    Answer,
    QuestionValidationTypes,
    IndicatorType,
    FormSection,
    IndicatorOperator,
} from 'interface';
import { __PipelineType } from 'interface/ucheck';
import { calcIndicator } from './questions/questionsTypes/questionsTypes.script';

export const detailForm2PreForm: (e: FormDetail) => PrevFormDetail = (preForm: FormDetail) => {
    return {
        first_page_description: preForm.first_page_description,
        first_page_title: preForm.first_page_title,
        first_page_bg: preForm.first_page_bg_file,
        hide_start_page: preForm.hide_start_page,
        has_password: preForm.has_password,
        start_button: preForm.start_button,
        lang: preForm.lang,
        title: preForm.title,
        background_image: preForm.background_image_file,
        background_color: preForm.background_color,
        logo_first_page_size: preForm.logo_first_page_size,
        logo_first_page: preForm.logo_first_page_file,
        button_label_color: preForm.button_label_color,
        password_title: preForm.password_title,
        has_footer: preForm.subscription?.has_footer,
        has_footer_content: preForm.subscription?.has_footer_content,
        ask_gps: preForm.ask_gps,
        direction: preForm.direction,
    };
};

// ---------------------------------- New Logical Relationship SLP ------------------------------------------

export const SLPLogicalRelationship = (
    data: FormDetail,
    answers: AnswerItem[],
    questionIndex?: number,
    answerer_info?: AnswererInfo[],
) => {
    const SLPquestions: Question[][] = [];

    const allQuestiones: Question[] = []; // with sub questions
    data = filterHide(data); // remove is_hidden sections and questions
    data.sections.map((sec) => {
        sec.questions.map((que) => {
            allQuestiones.push(que);
            que.children?.map((child) => allQuestiones.push(child));
        });
    });

    data.sections.map((sec) => {
        if (
            checkQuestionLogical(
                allQuestiones,
                answers,
                sec.section_logics,
                sec.logic_action,
                answerer_info,
                data.indicators,
            )
        ) {
            const secQuestiones: Question[] = [];
            sec.questions.map((que) => {
                const question = { ...que };
                question.children?.map((child) => {
                    if (
                        !checkQuestionLogical(
                            allQuestiones,
                            answers,
                            child.logics,
                            child.logic_action,
                            answerer_info,
                            data.indicators,
                        )
                    )
                        question.children = question.children?.filter((i) => i.id !== child.id);
                });
                if (
                    checkQuestionLogical(
                        allQuestiones,
                        answers,
                        question.logics,
                        question.logic_action,
                        answerer_info,
                        data.indicators,
                    )
                ) {
                    secQuestiones.push(question);
                }
            });
            SLPquestions.push(secQuestiones);
        }
    });
    return SLPPipelines(SLPquestions, answers, questionIndex, answerer_info, data.indicators);
};

const checkQuestionLogical = (
    questions: Question[],
    answers: AnswerItem[],
    logics?: QuestionLogic[],
    logic_action?: QuestionLogicAction,
    answerer_info?: AnswererInfo[],
    indicators?: IndicatorType[],
) => {
    if (!logics || logics.length === 0) return true;

    const questionsValidation: { questionId: number; valid?: boolean }[] = []; // has same length with logics
    const datalistValidation: { colNumber: number; valid?: boolean }[] = [];
    const indicatorValidation: { indicatorId: number; valid?: boolean }[] = [];
    const allLogics: QuestionLogic[] = [];
    questions.map((i) => i.logics?.map((j) => allLogics.push(j)));
    logics?.map((logic) => {
        const question = questions.find((i) => i.id === logic.answer_of);
        const DCN = logic.datalist_column_number;
        const indicatorLogic = logic.indicator;
        if (DCN !== undefined && DCN !== null) {
            const value = logic.value;
            const context = answerer_info?.find((i) => i.column === DCN);
            if (logic.operation === QuestionLogicOperator.hasValue) {
                datalistValidation.push({
                    colNumber: DCN,
                    valid: context !== null && context !== undefined && context.value !== '',
                });
            } else if (logic.operation === QuestionLogicOperator.noValue) {
                datalistValidation.push({
                    colNumber: DCN,
                    valid: context === null || context === undefined || context.value === '',
                });
            } else if (logic.operation === QuestionLogicOperator.equal) {
                datalistValidation.push({
                    colNumber: DCN,
                    valid: context !== null && context !== undefined && value?.includes(context.value),
                });
            } else if (logic.operation === QuestionLogicOperator.notEqual) {
                datalistValidation.push({
                    colNumber: DCN,
                    valid: context === null || context === undefined || !value?.includes(context.value),
                });
            }
        } else if (indicatorLogic) {
            const indicatorIndex = indicators?.findIndex((i) => i.id === Number(indicatorLogic));
            if (indicatorIndex !== undefined && indicatorIndex > -1 && indicators) {
                const value = logic.value;
                const indicatorValue = calcIndicator(indicators[indicatorIndex], answers).toString();
                if (logic.operation === QuestionLogicOperator.equal) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: value?.includes(indicatorValue),
                    });
                } else if (logic.operation === QuestionLogicOperator.notEqual) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: !value?.includes(indicatorValue),
                    });
                } else if (logic.operation === QuestionLogicOperator.bigger) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: Number(indicatorValue) > Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.biggerEQ) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: Number(indicatorValue) >= Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.lower) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: Number(indicatorValue) < Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.lowerEQ) {
                    indicatorValidation.push({
                        indicatorId: indicatorLogic,
                        valid: Number(indicatorValue) <= Number(value),
                    });
                }
            }
        } else if (question) {
            const answer = answers.find((i) => Number(i.question.id) === Number(question.id));
            if (
                [
                    QuestionTypes.simple,
                    QuestionTypes.email,
                    QuestionTypes.mobileNumber,
                    QuestionTypes.phoneNumber,
                    QuestionTypes.website,
                    QuestionTypes.date,
                    QuestionTypes.camera,
                    QuestionTypes.voice,
                    QuestionTypes.file,
                ].includes(question.input_type)
            ) {
                const value = logic.value;
                if (logic.operation === QuestionLogicOperator.hasAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer?.value !== undefined && answer.value.length > 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.noAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer?.value === undefined || answer.value.length === 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.equal) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer && answer.value !== undefined && value?.includes(answer.value),
                    });
                } else if (logic.operation === QuestionLogicOperator.notEqual) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer?.value === undefined || !value?.includes(answer.value),
                    });
                }
            } else if (
                [
                    QuestionTypes.number,
                    QuestionTypes.nps,
                    QuestionTypes.rate,
                    QuestionTypes.scale,
                    QuestionTypes.priority,
                ].includes(question.input_type)
            ) {
                const value = logic.value;
                if (logic.operation === QuestionLogicOperator.hasAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer?.value !== undefined && answer.value.length > 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.noAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer === undefined || answer.value === undefined || answer.value.length === 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.equal) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid:
                            answer?.value !== undefined && value?.map((i) => Number(i)).includes(Number(answer.value)),
                    });
                } else if (logic.operation === QuestionLogicOperator.notEqual) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid:
                            answer?.value !== undefined && !value?.map((i) => Number(i)).includes(Number(answer.value)),
                    });
                } else if (logic.operation === QuestionLogicOperator.bigger) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: Number(answer?.value) > Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.biggerEQ) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: Number(answer?.value) >= Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.lower) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: Number(answer?.value) < Number(value),
                    });
                } else if (logic.operation === QuestionLogicOperator.lowerEQ) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: Number(answer?.value) <= Number(value),
                    });
                }
            } else if (
                [
                    QuestionTypes.emoji,
                    QuestionTypes.dropDown,
                    QuestionTypes.matrix,
                    QuestionTypes.twoOptions,
                    QuestionTypes.selective,
                    QuestionTypes.pictureSelective,
                ].includes(question.input_type)
            ) {
                const logicItems = logic.question_items?.map((i) => Number(i));
                const items = answer ? answer.question_items?.map((i) => i.payload) : undefined;
                if (logic.operation === QuestionLogicOperator.hasAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid: answer?.question_items !== undefined && answer.question_items.length > 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.noAnswer) {
                    questionsValidation.push({
                        questionId: question.id,
                        valid:
                            answer === undefined ||
                            answer.question_items === undefined ||
                            answer.question_items.length === 0,
                    });
                } else if (logic.operation === QuestionLogicOperator.equal) {
                    let valid: boolean | undefined = undefined;
                    if (logicItems) {
                        valid = logicItems.filter((value) => items?.includes(value)).length > 0;
                    }
                    questionsValidation.push({ questionId: question.id, valid: valid });
                } else if (logic.operation === QuestionLogicOperator.notEqual) {
                    // questionsValidation.push({
                    let valid: boolean | undefined = undefined;
                    if (logicItems) {
                        valid = logicItems.filter((value) => items?.includes(value)).length === 0;
                    }
                    questionsValidation.push({ questionId: question.id, valid: valid });
                }
            }
        }
    });
    if (logic_action === QuestionLogicAction.and) {
        if (
            [...questionsValidation, ...datalistValidation, ...indicatorValidation].filter((i) => i.valid !== true)
                .length === 0
        )
            return true;
    } else if (
        [...questionsValidation, ...datalistValidation, ...indicatorValidation].map((i) => i.valid).includes(true)
    )
        return true;

    return false;
};

// ---------------------------------------- Set initial answer List ----------------------------------------

export const setInitialAnswerList = (
    answerList: AnswerItem[],
    questionIndex?: number,
    form?: FormDetail,
    answer?: Answer,
) => {
    if (!form) return answerList;

    const questions: Question[] = [];
    SLPLogicalRelationship(form, answerList, questionIndex, answer?.answerer_info).map((sec) =>
        sec.map((que) => questions.push(que)),
    );

    // set answer item for specefic question types
    questions.map((que) => {
        if (que.input_type === QuestionTypes.scale) {
            if (!answerList.map((i) => i.question.id).includes(que.id)) {
                const defaultVal = getValidationValue(que, QuestionValidationTypes.defaultValue);
                const minVal = getValidationValue(que, QuestionValidationTypes.min);
                answerList.push({
                    value: defaultVal ? defaultVal : minVal ? minVal : '0',
                    question: que,
                    id: new Date().getTime() + 1,
                    answer: answer?.id,
                });
            }
        } else if (que.input_type === QuestionTypes.priority) {
            que.children?.map((i, index) => {
                if (!answerList.map((j) => j.question.id).includes(i.id)) {
                    answerList.push({
                        value: i.order.toString(),
                        question: i,
                        id: new Date().getTime() + index,
                        answer: answer?.id,
                    });
                }
            });
        }
    });

    // add new answer items for questions apeare by new answer items
    const newQuestionList: Question[] = [];
    SLPLogicalRelationship(form, answerList, questionIndex, answer?.answerer_info).map((sec) =>
        sec.map((que) => newQuestionList.push(que)),
    );
    if (questions.length < newQuestionList.length)
        answerList = setInitialAnswerList(answerList, questionIndex, form, answer);

    return answerList;
};

function getValidationValue(question: Question, a: any) {
    if (question.validations) {
        return question.validations.find((i) => i.title === a)?.value?.toString();
    }
}

// ---------------------------------------- Pipeline Logics ----------------------------------------

const SLPPipelines = (
    questionList: Question[][],
    answers: AnswerItem[],
    questionIndex?: number,
    answerer_info?: AnswererInfo[],
    indicators?: IndicatorType[],
) => {
    const questions: Question[] = [];
    const allQuestions: Question[] = []; // with sub questions
    let pipelineQuestions: Question[] = []; // questions that should check in pipeline
    questionList.map((sec) => {
        sec.sort((a, b) => a.order - b.order).map((que) => {
            questions.push({ ...que, order: questions.length + 1 });
            allQuestions.push(que);
            que.children?.map((child) => allQuestions.push(child));
        });
    });
    questions.map((que, queIndex) => {
        if (questionIndex !== undefined && queIndex <= questionIndex)
            pipelineQuestions.push({ ...que, order: pipelineQuestions.length + 1 });
    });
    let newQuestions = [...questions];

    pipelineQuestions.map((que) => {
        if (newQuestions.map((i) => i.id).includes(que.id)) {
            let checkMorePipeline = true;
            sortedPipelines(questionList, que.pipelinecontainer_set).map((p) => {
                if (checkMorePipeline) {
                    const action = p.pipeline_action;
                    const targetOrder = questions.find((i) => i.id === p.pipeline_jump_to)?.order;
                    let checkMore = true;
                    let valid = false;
                    // let lastQueCheckOrder: number | undefined = undefined;

                    // first add data list items
                    const pipeList = p.pipeline_set ? p.pipeline_set.filter((i) => !i.answer_of) : [];
                    // then sort pipeline items by question orders
                    allQuestions.map((q) => {
                        const newPipe = p.pipeline_set?.find((i) => i.answer_of === q.id);
                        if (newPipe) pipeList.push(newPipe);
                    });

                    // check each pipeline item
                    pipeList.map((pipe) => {
                        if (checkMore) {
                            const question = allQuestions.find((i) => i.id === pipe.answer_of);
                            const DCN = pipe.datalist_column_number;
                            const indicatorLogic = pipe.indicator;
                            if (DCN !== undefined && DCN !== null) {
                                const value = pipe.value;
                                const context = answerer_info?.find((i) => i.column === DCN);
                                if (pipe.operation === QuestionLogicOperator.hasValue)
                                    valid = context !== null && context !== undefined && context.value !== '';
                                else if (pipe.operation === QuestionLogicOperator.noValue)
                                    valid = context === null || context === undefined || context.value === '';
                                else if (pipe.operation === QuestionLogicOperator.equal)
                                    valid =
                                        context !== null && context !== undefined && !!value?.includes(context.value);
                                else if (pipe.operation === QuestionLogicOperator.notEqual)
                                    valid =
                                        context === null || context === undefined || !value?.includes(context.value);
                            } else if (indicatorLogic) {
                                const indicatorIndex = indicators?.findIndex((i) => i.id === Number(indicatorLogic));
                                if (indicatorIndex !== undefined && indicatorIndex > -1 && indicators) {
                                    const value = pipe.value;
                                    const indicatorValue = calcIndicator(
                                        indicators[indicatorIndex],
                                        answers,
                                    ).toString();
                                    if (pipe.operation === QuestionLogicOperator.equal)
                                        valid = value !== undefined && value !== null && value.includes(indicatorValue);
                                    else if (pipe.operation === QuestionLogicOperator.notEqual)
                                        valid = !value?.includes(indicatorValue);
                                    else if (pipe.operation === QuestionLogicOperator.bigger)
                                        valid = Number(indicatorValue) > Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.biggerEQ)
                                        valid = Number(indicatorValue) >= Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.lower)
                                        valid = Number(indicatorValue) < Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.lowerEQ)
                                        valid = Number(indicatorValue) <= Number(value);
                                }
                            } else if (question) {
                                const answer = answers.find((i) => Number(i.question.id) === Number(question.id));
                                if (
                                    [
                                        QuestionTypes.simple,
                                        QuestionTypes.email,
                                        QuestionTypes.mobileNumber,
                                        QuestionTypes.phoneNumber,
                                        QuestionTypes.website,
                                        QuestionTypes.date,
                                        QuestionTypes.camera,
                                        QuestionTypes.voice,
                                        QuestionTypes.file,
                                    ].includes(question.input_type)
                                ) {
                                    const value = pipe.value;
                                    if (pipe.operation === QuestionLogicOperator.hasAnswer)
                                        valid = answer?.value !== undefined && answer.value.length > 0;
                                    else if (pipe.operation === QuestionLogicOperator.noAnswer)
                                        valid = answer?.value === undefined || answer.value.length === 0;
                                    else if (pipe.operation === QuestionLogicOperator.equal)
                                        valid =
                                            !!answer && answer.value !== undefined && !!value?.includes(answer.value);
                                    else if (pipe.operation === QuestionLogicOperator.notEqual)
                                        valid = answer?.value === undefined || !value?.includes(answer.value);
                                } else if (
                                    [
                                        QuestionTypes.number,
                                        QuestionTypes.nps,
                                        QuestionTypes.rate,
                                        QuestionTypes.scale,
                                        QuestionTypes.priority,
                                    ].includes(question.input_type)
                                ) {
                                    const value = pipe.value;
                                    if (pipe.operation === QuestionLogicOperator.hasAnswer)
                                        valid = answer?.value !== undefined && answer.value.length > 0;
                                    else if (pipe.operation === QuestionLogicOperator.noAnswer)
                                        valid =
                                            answer === undefined ||
                                            answer.value === undefined ||
                                            answer.value.length === 0;
                                    else if (pipe.operation === QuestionLogicOperator.equal)
                                        valid =
                                            answer?.value !== undefined &&
                                            value !== undefined &&
                                            value.map((i) => Number(i)).includes(Number(answer.value));
                                    else if (pipe.operation === QuestionLogicOperator.notEqual)
                                        valid =
                                            answer?.value !== undefined &&
                                            value !== undefined &&
                                            !value?.map((i) => Number(i)).includes(Number(answer.value));
                                    else if (pipe.operation === QuestionLogicOperator.bigger)
                                        valid = Number(answer?.value) > Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.biggerEQ)
                                        valid = Number(answer?.value) >= Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.lower)
                                        valid = Number(answer?.value) < Number(value);
                                    else if (pipe.operation === QuestionLogicOperator.lowerEQ)
                                        valid = Number(answer?.value) <= Number(value);
                                } else if (
                                    [
                                        QuestionTypes.emoji,
                                        QuestionTypes.dropDown,
                                        QuestionTypes.matrix,
                                        QuestionTypes.twoOptions,
                                        QuestionTypes.selective,
                                        QuestionTypes.pictureSelective,
                                    ].includes(question.input_type)
                                ) {
                                    const logicItems = pipe.question_items?.map((i) => Number(i));
                                    const items = answer ? answer.question_items?.map((i) => i.payload) : undefined;
                                    if (pipe.operation === QuestionLogicOperator.hasAnswer)
                                        valid =
                                            answer?.question_items !== undefined && answer.question_items.length > 0;
                                    else if (pipe.operation === QuestionLogicOperator.noAnswer)
                                        valid =
                                            answer === undefined ||
                                            answer.question_items === undefined ||
                                            answer.question_items.length === 0;
                                    else if (pipe.operation === QuestionLogicOperator.equal)
                                        valid =
                                            logicItems !== undefined &&
                                            logicItems.filter((value) => items?.includes(value)).length > 0;
                                    else if (pipe.operation === QuestionLogicOperator.notEqual)
                                        valid =
                                            logicItems === undefined ||
                                            logicItems.filter((value) => items?.includes(value)).length === 0;
                                }
                            }
                            if (
                                (valid && action === QuestionLogicAction.or) ||
                                (!valid && action === QuestionLogicAction.and)
                            ) {
                                checkMore = false;
                            }
                        }
                    });
                    if (valid && targetOrder !== undefined) {
                        // remove from order last question in pipeline to target
                        newQuestions = questions.filter(
                            (q) =>
                                newQuestions.map((i) => i.id).includes(q.id) &&
                                (q.order >= targetOrder || q.order <= que.order),
                        );
                    } else if (valid && !p.pipeline_jump_to) {
                        // end answering
                        newQuestions = questions.filter(
                            (q) => newQuestions.map((i) => i.id).includes(q.id) && q.order <= que.order,
                        );
                    }
                    if (valid) {
                        checkMorePipeline = false;
                        pipelineQuestions = [];
                        newQuestions.map((que, queIndex) => {
                            if (questionIndex !== undefined && queIndex <= questionIndex)
                                pipelineQuestions.push({ ...que, order: pipelineQuestions.length + 1 });
                        });
                    }
                }
            });
        }
    });
    const newList: Question[][] = [];
    questionList.map((sec) => {
        const ques: Question[] = [];
        sec.map((que) => {
            if (newQuestions.map((i) => i.id).includes(que.id)) ques.push(que);
        });
        newList.push(ques);
    });
    return newList;
};

const filterHide = (data: FormDetail) => {
    // remove is_hidden question and section
    return {
        ...data,
        sections: data.sections
            .filter((s) => !s.is_hidden)
            .map((s) => ({ ...s, questions: s.questions.filter((q) => !q.is_hidden) })),
    };
};

const sortedPipelines = (sections: Question[][], pipelines?: __PipelineType[]) => {
    const maxIds = findQueOrder(sections, undefined, true) ?? 0;
    return pipelines
        ? pipelines.sort(
              (a, b) =>
                  (findQueOrder(sections, a.pipeline_jump_to) ?? maxIds) -
                  (findQueOrder(sections, b.pipeline_jump_to) ?? maxIds),
          )
        : [];
};

const findQueOrder = (questionsList: Question[][], id?: number | null, len = false) => {
    // find order of question base on question id
    const questions: Question[] = [];
    questionsList.map((s) =>
        s.sort((a, b) => a.order - b.order).map((q) => questions.push({ ...q, order: questions.length + 1 })),
    );
    if (len) return questions.length + 1;
    return questions.find((i) => i.id === id)?.order;
};
